import React, { useContext } from 'react'
import { OnboardingV3Context } from 'context/onboarding-v3'
import ModalFinalOnboardingV3 from 'components/modals/modal-final-onboarding-v3'

const OnboardingV3Orchestrator = () => {
  const { showFinalModal, setShowFinalModal } = useContext(OnboardingV3Context)

  const handleClose = () => {
    setShowFinalModal(false)
  }

  return (
    <ModalFinalOnboardingV3 isOpen={showFinalModal} onClose={handleClose} />
  )
}

export default OnboardingV3Orchestrator
